import { ChangeDetectorRef, Component, Input, OnInit } from '@angular/core';
import { BookingStatus } from 'app/shared/models/class/bookedOffer/bookedOffer';
import { FilterPopUpTable } from 'app/shared/models/class/filterPopupTable/filterPopUpTable';
import { BookingService } from 'app/shared/services/booking/booking.service';
import { DataService } from 'app/shared/services/data/data.service';
import { FaiconService } from 'app/shared/services/faicon/faicon.service';
import { SubscriptionBaseComponent } from 'app/shared/subscriptionBase/subscription-base';

@Component({
  selector: 'app-pop-up-filter',
  templateUrl: './pop-up-filter.component.html',
  styleUrls: ['./pop-up-filter.component.scss']
})
export class PopUpFilterComponent extends SubscriptionBaseComponent implements OnInit {
  @Input() idFilter: string;
  @Input() column: string;
  @Input() offers: any[];
  @Input() status: string[];

  valueFilter: string[];
  valuefilterSelected = new FilterPopUpTable();
  bookingStatus: BookingStatus[];

  constructor(
    private dataService: DataService,
    private cdr: ChangeDetectorRef,
    private bookingService: BookingService,
    private faIconService: FaiconService,
  ) {
    super();
  }

  ngOnInit() {
  }

  getFaIcon(faIcon: string): string {
    return this.faIconService.getFaIcon(faIcon);
  }

  async showFilter(id: string, column: string) {
    await this.closePopup();
    // this.valueFilter = [];

    const valueFilter = {
      bookingReference: this.offers.map(offer => offer?.bookingReference),
      offername: this.offers.map(offer => offer?.offerName),
      price: this.offers.map(offer => offer?.price),
      status: this.status,
      bookingamount: this.offers.map(offer => offer?.bookingAmount),
      bookingGlobalStatus: this.offers.map(offer => offer?.bookingGlobalStatus),
      ressources: this.offers.map(offer => offer?.ressources),
      isCustomerNotified: this.offers.map(offer => offer?.isCustomerNotified),
    };

    this.valueFilter = valueFilter[column];

    this.valueFilter = this.valueFilter?.filter((value, index) => this.valueFilter.indexOf(value) === index);
    this.dataService.valueFilterPopUpChoice$.next(this.valueFilter);

    const filter = document.getElementById(id);
    filter.style.display = 'block';
  }

  private returStatus(statusKey: number): BookingStatus {
    return this.bookingStatus?.find(status => status.bookedOfferStatusKey === statusKey);
  }

  private closePopup(): void {
    this.dataService.resetPopUp();
  }


}
